import { render, staticRenderFns } from "./physiologicalPeople.vue?vue&type=template&id=9488d58e&"
import script from "./physiologicalPeople.vue?vue&type=script&lang=js&"
export * from "./physiologicalPeople.vue?vue&type=script&lang=js&"
import style0 from "./physiologicalPeople.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./physiologicalPeople.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "physiologicalPeople.vue"
export default component.exports